import { PureComponent } from "react";
import { Brightcove } from "./Brightcove/Brightcove";
import { Qumu } from "./Qumu/Qumu";
import { YoutubePreload } from "./Youtube/YoutubePreload";
import { OpenMeet } from "./OpenMeet/OpenMeet";
import sanitize from "sanitize-filename";

export class VideoPlayer extends PureComponent {
    static Brightcove = Brightcove;
    static Qumu = Qumu;
    static Youtube = YoutubePreload;
    static OpenMeet = OpenMeet;
}

/**
 * Supported local thumbnail providers.
 * @see /scripts/get-video-posters.ts
 */
export const SupportedLocalThumbProviders = ["brightcove", "youtube", "qumu"];

/**
 * Returns a local URL for the thumbnail image.
 * @param videoId
 * @param provider
 * @returns
 */
export const getLocalThumbnailUrl = (videoId: string, provider: string): string => {
    return `/video-posters/${provider}/${sanitize(videoId)}.jpg`;
};
